import { render } from "./SubUsersView.vue?vue&type=template&id=7096fabf&scoped=true"
import script from "./SubUsersView.vue?vue&type=script&lang=js"
export * from "./SubUsersView.vue?vue&type=script&lang=js"

import "./SubUsersView.vue?vue&type=style&index=0&id=7096fabf&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7096fabf"]])

export default __exports__